import Tile from "./tile";

class Level {
  constructor(id, builder, config) {
    const { tiles, portals, features } = builder(config);
    this.tiles = tiles;
    this.portals = portals;
    this.features = features;
    this.id = id;
    this.config = config;
  }

  get screenName() {
    return this.config.name;
  }

  get width() {
    return this.config.width;
  }

  get height() {
    return this.config.height;
  }

  get entrancePortalTile() {
    const point = this.portals.entrance;

    if (point) {
      return this.tiles[point.y][point.x];
    }
  }

  set entrancePortalTile(tile) {
    const point = this.portals.entrance;

    if (point) {
      this.tiles[point.y][point.x] = tile;
    }
  }

  get exitPortalTile() {
    const point = this.portals.exit;

    if (point) {
      return this.tiles[point.y][point.x];
    }
  }

  set exitPortalTile(tile) {
    const point = this.portals.exit;

    if (point) {
      this.tiles[point.y][point.x] = tile;
    }
  }

  connectPortals(fromLevel) {
    this.entrancePortalTile = Tile.portal(
      this.entrancePortalTile.name,
      this.entrancePortalTile.desc,
      fromLevel.id,
      fromLevel.portals.exit
    );

    fromLevel.exitPortalTile = Tile.portal(
      this.exitPortalTile.name,
      this.exitPortalTile.desc,
      this.id,
      this.portals.entrance
    );
  }

  populateScene(stage) {
    if (this.config.drops) {

    }

    if (this.config.monsters) {

    }

    if (this.config.scene) {
      this.config.scene(stage, this.features);
    }

    if (this.portals.entrance) {
      stage.spawnEntity(stage.player, this.portals.entrance.x, this.portals.entrance.y);
    } else if (this.portals.start) {
      stage.spawnEntity(stage.player, this.portals.start.x, this.portals.start.y);
    } else {
      throw new ("Level cannot be loaded without a valid portal entrance");
    }
  }

  revisitScene(stage) {
    if (this.portals.entrance) {
      stage.spawnEntity(stage.player, this.portals.entrance.x, this.portals.entrance.y);
    } else if (this.portals.start) {
      stage.spawnEntity(stage.player, this.portals.start.x, this.portals.start.y);
    } else {
      throw new ("Level cannot be loaded without a valid portal entrance");
    }
  }
}

export default Level;
